import { Box, List, ListItem, styled } from "@mui/material";

const Styled = {
    ListContainer: styled(Box)`
        background: ${({ theme }) => theme.palette.background.paper};
        padding: 16px 24px;
        max-height: 400px;
        overflow-y: auto;
        border-radius: 16px;
        box-shadow: 0 2px 12px rgba(0,0,0,0.06);
    `,
    ProductsList: styled(List)`
        display: flex;
        flex-direction: column;
        gap: 12px;
        max-height: 400px;
        overflow: hidden;
        padding: 0;

        & .MuiListSubheader-root {
            color: ${({ theme }) => theme.palette.text.primary};
            font-size: 18px;
            font-weight: 600;
            padding-left: 0;
            line-height: 1.3;
            letter-spacing: 0.5px;
        }

        & .MuiListItemText-root {
            margin: 0;
        }

        & .MuiListItemIcon-root {
            min-width: 24px;
        }

        &:first-of-type {
            padding-top: 12px;
            border: none;

            & div .MuiBox-root {
                display: none;
            }
        }
    `,
    BrandsList: styled(List)`
        display: flex;
        flex-direction: column;
        gap: 10px;

        & .MuiListSubheader-root {
            font-size: 15px;
            padding: 0 8px;
            margin-top: 4px;
            color: ${({ theme }) => theme.palette.text.secondary};
            font-weight: 500;
        }
    `,
    ParticipantProducts: styled(ListItem)`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 20px;
        border-radius: 10px;
        margin-bottom: 2px;
        background: ${({ theme }) => theme.palette.action.hover};
        transition: box-shadow 0.2s, background 0.2s;

        &:hover {
            background: ${({ theme }) => theme.palette.secondary.light}22;
            box-shadow: 0 2px 8px rgba(108, 94, 207, 0.08);
        }

        & .MuiButtonBase-root {
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-right: 4px;
            padding-bottom: 4px;
            border-radius: 50%;

            &:hover {
                background-color: ${({ theme }) => theme.palette.secondary.light}33;
            }

            & svg {
                fill: ${({ theme }) => theme.palette.secondary.main};
                width: 22px;
                height: 22px;
            }
        }
    `,
    Border: styled("div")`
        border-top: 1px dashed ${({ theme }) => theme.palette.divider};
        margin: 8px 0;
    `,
};

export { Styled };
